"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertNotificationSidebar = void 0;
const tabs_1 = require("./tabs/tabs");
const react_1 = __importStar(require("react"));
const styled_1 = require("./styled");
const alert_notification_sidebar_content_1 = require("./sidebar-content/alert-notification-sidebar-content");
const components_1 = require("../../components");
const link_1 = require("./utils/link");
/**
 * Type definition for the properties of the Alert Notification Sidebar component.
 * @property {Array<TabT>} tabs - An array of TabT objects representing the tabs to be displayed.
 * @property {TabType} selectedTab - The currently selected tab.
 * @property {(tab: TabType) => void} onTabSelect - Function to call when a tab is selected.
 * @property {boolean} [isTabDataLoading] - Optional. Indicates if the tab data is currently loading.
 * @property {() => void} [onShowMore] - Optional. Function to call when the "Show More" button is clicked.
 * @property {boolean} [showFooter] - Optional. Indicates if the footer should be displayed.
 * @property {AsidePortalPropsT} - Additional properties inherited from AsidePortalPropsT.
 */
const AlertNotificationSidebar = (_a) => {
    var _b;
    var { tabs, selectedTab = 'alerts', onTabSelect, isTabDataLoading, onShowMore, handleResizeSide = 'left', showFooter } = _a, asideProps = __rest(_a, ["tabs", "selectedTab", "onTabSelect", "isTabDataLoading", "onShowMore", "handleResizeSide", "showFooter"]);
    const activeContent = (0, react_1.useMemo)(() => tabs.find(({ id }) => id === selectedTab), [selectedTab, tabs]);
    return (react_1.default.createElement(components_1.AsidePortal, Object.assign({ handleResizeSide: handleResizeSide, id: "alert-notification-sidebar", title: "Alerts & Notifications ", Content: styled_1.AsideContent, Footer: ((_b = activeContent === null || activeContent === void 0 ? void 0 : activeContent.sections) === null || _b === void 0 ? void 0 : _b.length) && showFooter ? (react_1.default.createElement(link_1.ShowMoreLink, { onClick: onShowMore })) : undefined }, asideProps),
        react_1.default.createElement(styled_1.Wrapper, null,
            react_1.default.createElement(tabs_1.Tabs, { tabs: tabs, selectedTab: selectedTab, onSelect: onTabSelect }),
            activeContent && (react_1.default.createElement(alert_notification_sidebar_content_1.AlertNotificationSidebarContent, { totalItems: activeContent.totalCount, title: activeContent.title, isTabDataLoading: isTabDataLoading, type: activeContent.id, sections: activeContent.sections })))));
};
exports.AlertNotificationSidebar = AlertNotificationSidebar;
